// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"31":"otpverification","156":"forget","787":"signup","945":"dashboard","966":"login"}[chunkId] + "." + {"31":"0150023c","156":"52e4c161","787":"82eb3bd5","945":"cdb7b65d","966":"48daf4d2"}[chunkId] + ".css";
};